import { setCookie } from "Functions/cookie";

// Zavretie androidového smart app bannera (app_smart_banner.ctp). Rozhodnutie
// držíme v cookie, nie v localStorage — element sa gatuje server-side, takže
// banner po zavretí ani neprebliskne. Rovnaký vzor ako info-messages.js.
const banner = document.querySelector(".js-app-smart-banner");

if (banner) {
    banner.querySelector(".js-app-smart-banner-close").addEventListener("click", (event) => {
        event.preventDefault();

        setCookie("app-banner-hidden", "1", 30);

        banner.remove();
    });
}
